import {
  Edit,
  SimpleForm,
  TextInput,
  DateTimeInput
} from "react-admin";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Grid } from "@mui/material";
import Title from "../../ra/edit/title";
import {
  validDate
} from "../../utils/schemas";
import { Save as ToolbarSave } from "../../ra/toolbar";

const Schema = Yup.object({
  date_withdrawal: validDate()
});

const CustomerPassportPhysicalEdit = () =>
{
  return (
    <Edit
      title={<Title subtitle="Editar Entrega de Passaporte Físico" source="customer_passport_and_name" />}
      redirect="list"
      mutationMode="pessimistic">
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={<ToolbarSave />}>
        <Box
          sx={{
            width: { xs: "100%", md: "auto" },
            maxWidth: { xs: "100%", md: 980 },
            display: { xs: "block", md: "inline-block" },
            alignSelf: "flex-start",
          }}>
          <Grid container columnSpacing={2} rowSpacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextInput source="collection_point_passport_name" label="Ponto de Retirada" fullWidth disabled />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} />

            <Grid size={{ xs: 12, md: 6 }}>
              <TextInput source="collection_point_passport_admin_name" label="Entregue por" fullWidth disabled />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} />

            <Grid size={{ xs: 12, md: 6 }}>
              <TextInput source="customer_passport_and_name" label="Usuário" fullWidth disabled />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} />

            <Grid size={{ xs: 12, md: 6 }}>
              <DateTimeInput source="date_withdrawal" label="Data da Retirada" fullWidth isRequired />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} />
          </Grid>
        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default CustomerPassportPhysicalEdit;
